(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('AsideMenuViewModel', asideMenuViewModelFactory);

  /** @ngInject */
  function asideMenuViewModelFactory(
    $translate,
    brand,
    checkUserRole,
    service,
    helperService,
    jwtHelper,
    sessionData
  ) {
    function AsideMenuViewModel() {
      this.items = [];
      this.shouldHideSidebar = false;
      var token = sessionData.getValue(sessionData.Keys.ACCESS_TOKEN_KEY);
      var claims = token ? jwtHelper.decodeToken(token) : {};
      this._isCompanyUser = 'isCompanyLevel' in claims ? !!claims.isCompanyLevel : true;
      this.refresh();
    }

    AsideMenuViewModel.prototype.destroy = function () {
      this.items = [];
    };

    AsideMenuViewModel.prototype.refresh = function () {
      // Cashier-only users see only Rollover menu item (not for R2W platform)
      if (checkUserRole.isCashier() && !checkUserRole.isMerchantAdmin()) {
        if (this._isCompanyUser && brand !== 'r2w') {
          this.items.push({
            id: 'app.rollover',
            name: $translate.instant('ASIDE_MENU_ROLLOVER'),
            icon: 'assets/icons/ic_rollover_white.svg',
            link: '',
            subMenuItems: []
          });
        }
        return; // Exit early - Cashier only sees Rollover
      }

      this.items.push({
        id: 'app.dashboardTechnology',
        name:
          brand === 'karcher'
            ? $translate.instant('ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY')
            : $translate.instant('ASIDE_MENU_DASHBOARD_TECHNOLOGY'),
        icon: 'assets/icons/ic-dashboard-white.svg',
        link: '',
        subMenuItems: []
      });
      if (checkUserRole.isMerchantAdmin() && service && this._isCompanyUser) {
        this.items.push({
          id: 'app.dashboardFinancial',
          name: $translate.instant('ASIDE_MENU_DASHBOARD_FINANCIAL'),
          icon: 'assets/icons/ic-daily-finances-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) {
        this.items.push({
          id: 'app.organization',
          name: $translate.instant('ORGANIZATION'),
          icon: 'assets/icons/ic_organization_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (
        (checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) &&
        service
      ) {
        this.items.push({
          id: 'app.workingSchedules',
          name: $translate.instant('ASIDE_WORKING_SCHEDULES'),
          icon: 'assets/icons/ic_content_paste_white_48px.svg',
          link: '',
          subMenuItems: [],
          roles: []
        });
      }
      this.items.push({
        id: 'app.alarms',
        name: $translate.instant('ASIDE_MENU_ALARMS'),
        icon: 'assets/icons/ic-messages-white.svg',
        link: '',
        subMenuItems: []
      });
      // this.items.push({
      //     id: 'app.news',
      //     name: $translate.instant('ASIDE_MENU_NEWS'),
      //     icon: "assets/icons/ic_comment_white_24px.svg",
      //     link: "",
      //     subMenuItems: []
      // });
      if ((
        checkUserRole.isMerchantAdmin() ||
        checkUserRole.isAdministrator() ||
        checkUserRole.isTechnicalSupportUser() ||
        checkUserRole.isControllerUser())
      ) {
        this.items.push({
          id: 'app.reports',
          name: $translate.instant('ASIDE_MENU_REPORTS'),
          icon: 'assets/icons/ic-reports-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (
        (checkUserRole.isMerchantAdmin() ||
          checkUserRole.isAdministrator() ||
          checkUserRole.isTechnicalSupportUser() ||
          checkUserRole.isControllerUser()) && this._isCompanyUser
      ) {
        this.items.push({
          id: 'app.cashlessSales',
          name: $translate.instant('ASIDE_MENU_CASHLESS_SALES'),
          icon: 'assets/icons/ic_cashless.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (
        (checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) &&
        service
      ) {
        this.items.push({
          id: 'app.userGroups',
          name: $translate.instant('ASIDE_MENU_USER_GROUPS'),
          icon: 'assets/icons/ic-user-groups-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.loyalty',
          name: $translate.instant('ASIDE_MENU_LOYALTY'),
          icon: 'assets/icons/ic-loyalty-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.periodicSummary',
          name: $translate.instant('ASIDE_MENU_PERIODIC_SUMMARY'),
          icon: 'assets/icons/ic-periodic-summary-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && (brand === 'r2w' || helperService.showVouchersSideItemByUserId())) {
        this.items.push({
          id: 'app.vouchers',
          name: $translate.instant('ASIDE_MENU_VOUCHERS'),
          icon: 'assets/icons/ic-vouchers-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if ((checkUserRole.isMerchantAdmin() || checkUserRole.isCashier()) && this._isCompanyUser && brand !== 'r2w' && false) {
        this.items.push({
          id: 'app.rollover',
          name: $translate.instant('ASIDE_MENU_ROLLOVER'),
          icon: 'assets/icons/ic_rollover_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.transactions',
          name: $translate.instant('ASIDE_MENU_TRANSACTIONS'),
          icon: 'assets/icons/ic-transactions-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.tokens',
          name: $translate.instant('ASIDE_MENU_MANAGING_TOKENS'),
          icon: 'assets/icons/coins_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.pricing',
          name: $translate.instant('PRICING'),
          icon: 'assets/icons/ic_dolar_circle_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && this._isCompanyUser && false) {
        this.items.push({
          id: 'app.savings',
          name: $translate.instant('ASIDE_MENU_SAVINGS'),
          icon: 'assets/icons/ic_savings_white.svg',
          link: '',
          subMenuItems: []
        });
      }

      // Hide sidebar if user has access to only one tab or no tabs
      this.shouldHideSidebar = this.items.length <= 1;
    };

    return AsideMenuViewModel;
  }
})();
